import React, { useEffect, useRef, useState } from "react";
import Header from "../shared/Header";
import Hero from "../panels/Hero/Hero";
import HowItWorks from "../panels/HowItWorks/HowItWorks";
import Partners from "../panels/Partners/Partners";
import Contact from "../panels/Contact/Contact";
import Samples from "../panels/Samples/Samples";
import Footer from "../panels/Footer/Footer";
import SliderPage from "./SliderPage/SliderPage";
import HeroImages from "../panels/HeroImages/HeroImages";
import { render } from "enzyme";
import fetchRecentSamples from "../../api/fetchRecentSamples";
import fetchTestinomials from "../../api/fetchTestimonials";
import fetchSampleTuesdayDate from "../../api/fetchSampleTuesdayDate";
import { useDispatch } from "react-redux";

function Signup() {
  const dispatch = useDispatch();
  //Set sign up menu open
  const [isLoginOpen, setLoginOpen] = useState(false);
  //Change sign up menu to sign in
  const [isLogin, setIsLogin] = useState(true);

  //refs
  const signUpRef = useRef();

  //ref handler
  const scrollToRef = ref => window.scrollTo(0, ref.current.offsetTop);
  const executeScroll = ref => scrollToRef(ref);

  //open menu based on parameter
  const menuHandler = menuType => {
    setIsLogin(menuType);
    setLoginOpen(true);
  };

  useEffect(() => {
    dispatch(fetchTestinomials());
    dispatch(fetchRecentSamples());
    dispatch(fetchSampleTuesdayDate());
  }, []);

  return (
    <>
      <Header menuHandler={menuHandler} />
      <Hero
        isLogin={isLogin}
        setIsLogin={setIsLogin}
        isLoginOpen={isLoginOpen}
        setLoginOpen={setLoginOpen}
        signUpRef={signUpRef}
        menuHandler={menuHandler}
      />
      <HeroImages />
      <HowItWorks />
      <SliderPage />
      <Partners />
      <Contact />
      <Samples onScroll={() => executeScroll(signUpRef)} />
      <Footer />
    </>
  );
}

export default Signup;
